import React from 'react'
import { createContext, useContext, useState, useEffect } from "react";

const Online = createContext();

export const OnlineProvider = ({children})=>{
  const[online,setOnline] = useState((/Linux/.test(window.navigator.platform))||window.navigator.onLine)
  useEffect(() => {
    const offline = () =>{
      console.log('offline');
      if(!(/Linux/.test(window.navigator.platform)))
      setOnline(false);
    }    

    const online = () =>{
      console.log('online');
      setOnline(true);
    }
    window.addEventListener("online",online);
    window.addEventListener("offline",offline);
    return () => {
       window.removeEventListener("online",online);
       window.removeEventListener("offline",offline);
      }
  }, []);

  return (
    <Online.Provider value={online?true:false}>
        {children}
    </Online.Provider>
  )
};

export const useOnline = () => {
  return useContext(Online);
};